var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drvers"},[_c('LogsList',{attrs:{"type":`managers`}},[_c('PageTitle',{attrs:{"title":"SIDE_MENU.LOGS","subtitle":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }